import React from 'react';
import { StyleSheet } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import {
    PromotionDocumentDataBodyNumberedSliceItem,
    Rafv2DocumentDataSenderStepsItem,
} from '@/types/prismic.generated';

export const getPromotionStepContents = (
    steps?: Rafv2DocumentDataSenderStepsItem[] | PromotionDocumentDataBodyNumberedSliceItem[]
): string[] | null => {
    return steps
        ? Object.keys(steps).reduce((acc, key) => {
              const step = steps[Number(key)];
              if ('step' in step && step.step) {
                  acc.push(step.step);
              } else if ('content' in step && step.content) {
                  acc.push(step.content);
              }

              return acc;
          }, [] as string[])
        : null;
};

type HowItWorksStepsProps = {
    steps: string[];
    title?: string | null;
};

export const HowItWorksSteps = ({ title, steps }: HowItWorksStepsProps) => {
    return (
        <>
            {title ? (
                <Text variant={'headlineMedium'} lineHeight={28} paddingBottom={'s20'}>
                    {title}
                </Text>
            ) : null}
            <Box paddingBottom={'s36'}>
                {steps?.map((step, index) => (
                    <Row
                        paddingBottom={index < steps.length - 1 ? 's16' : 's0'}
                        key={`${step}-${index}`}
                        alignItems={'flex-start'}
                    >
                        <Box
                            backgroundColor={ds.colorToken.background.neutral.inverse}
                            width={24}
                            height={24}
                            borderRadius={'r20'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            marginRight={'s16'}
                        >
                            <Text variant={'labelMedium'} color={'neutral900'} fontWeight={'700'}>
                                {index + 1}
                            </Text>
                        </Box>
                        <Text variant={'bodyMedium'} color={ds.colorToken.text.primary} style={styles.textShrink}>
                            {step}
                        </Text>
                    </Row>
                ))}
            </Box>
        </>
    );
};

const styles = StyleSheet.create({
    textShrink: {
        flexShrink: 1,
    },
});
